module.exports = __webpack_public_path__ + "img/STERiJECT_s2.886026da.png";